import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_catalogo, cambios_no_guardados } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';

import ModalService from '../../../ModalService/ModalService';
import AlertForm from '../../../../../../Services/AlertForm';
import FormularioGiros from './FormularioGiros';

const ModalEditGiros = ({ openEdit, setOpenEdit, elementSelect, editar, errorTable, nombreModulo}) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenEdit( false );
        setError( null );
    }

    const actualizarGiro = ( giro, giroId ) => {
        axios.put( `${servicios_grupogack_catalogo}s/giros/${giroId}`, giro, headersAuth() )
            .then( respuesta => {
                //console.log( respuesta );
                switch( respuesta.data.status ){
                    case 200:
                        const { nombre: giroNom } = giro;
                        editar({ id: giroId, giroNom });
                        setOpenEdit( false );
                        break;
                    case 404:
                        setError( <AlertForm message={ respuesta.data.msg } /> );
                        //errorTable( respuesta.data.msg );
                        break;
                    default:
                        errorTable( cambios_no_guardados );
                        break;
                }
            })
            .catch( error => {
                errorTable( cambios_no_guardados );
            })
    }

    return (
        <ModalService title="Actualizar Giro" parentNode={nombreModulo} minWidth="40%"
            isOpen={ openEdit } onClose={ () => cerrarModal() } >
                <FormularioGiros
                    error={error}
                    elementSelect={elementSelect}
                    actualizarGiro={actualizarGiro}
                />
        </ModalService>
    );
};

export default ModalEditGiros;